export function jsonpPost(url, payload, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const callbackName = 'jsonp_cb_' + Date.now() + '_' + Math.floor(Math.random() * 10000);
    // attach callback
    window[callbackName] = function(response) {
      try {
        resolve(response);
      } finally {
        try { delete window[callbackName]; } catch (e) {}
        if (script.parentNode) script.parentNode.removeChild(script);
      }
    };

    const script = document.createElement('script');
    const dataParam = encodeURIComponent(JSON.stringify(payload));
    const sep = url.indexOf('?') === -1 ? '?' : '&';
    script.src = `${url}${sep}data=${dataParam}&callback=${callbackName}`;
    script.onerror = function(e) {
      try { delete window[callbackName]; } catch (er) {}
      if (script.parentNode) script.parentNode.removeChild(script);
      reject(new Error('JSONP request failed'));
    };

    document.body.appendChild(script);

    // timeout
    const to = setTimeout(() => {
      if (window[callbackName]) {
        try { delete window[callbackName]; } catch (er) {}
        if (script.parentNode) script.parentNode.removeChild(script);
        reject(new Error('JSONP timeout'));
      }
    }, timeout);
  });
}
